<template>
  <div name="demo-validate-required-any">
    <hrms-timepicker  v-model="timstrt" 
                      v-validate="'requiredAny:timstrt,timend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timstrt"
                      name="timstrt"
                      :has-error="errors.has('timstrt')" />
    <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>

    <hrms-timepicker  v-model="timend" 
                      v-validate="'requiredAny:timstrt,timend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timend"
                      name="timend"
                      :has-error="errors.has('timend')" />
    <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-required-any'
}
</script>


// WEBPACK FOOTER //
// demoValidateRequiredAny.vue?2aaf7052